var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-history-list-header"},[_c('div',{staticClass:"header-left"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"header-right"},[_c('i',{staticClass:"el-icon-close",on:{"click":_vm.onClose}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/cache-loader/dist/cjs.js!./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-589373e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/pages/home/drawer/drawer-header.vue
// module id = null
// module chunks = 